<template>

	<section class="section">

		<svg height="0" width="0" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 87.04 148.97">
			<defs></defs>
			<clipPath id="rose" clipPathUnits="objectBoundingBox" transform="scale(0.01148897,0.00671276)">
			<path class="cls-1" d="M34,.5C24.44.5,21.16,5.78,14.59,11.7.79,28.78.5,58.35.5,74.5S11.3,93.83,15.57,105s-2,22.67,1.32,32.52,7.23,12.81,14.78,9.86S47.11,117.5,54,106.64s29.24-20,31.87-40.08-3-42.46-10.51-52.23S43.5.5,34,.5Z"/>
			</clipPath>
		</svg>

		<svg  height="0" width="0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 557.28 541"><defs></defs>
			<clipPath id="transp" clipPathUnits="objectBoundingBox" transform="scale(0.00179443008,0.00184842883)">
			<path d="M556.4,277.56c8.43,196.17-125.2,262.91-278.22,262.91C178.56,542.64-20.31,437.33,2.27,277.56S107.09.5,279.33.5,548,81.39,556.4,277.56Z" transform="translate(0)"/>
			</clipPath>
		</svg>

		<svg height="0" width="0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160.53 129">
			<defs>
			</defs>
			<clipPath id="bleu" clipPathUnits="objectBoundingBox" transform="scale(0.00622936522,0.00775193798)">
			<path d="M102.36,16.79c-15,0-8,15-27,20.5s-65-13.5-73,23.5,22,37.48,35,48c12,9.72,17,36,65,36s46-12,56-31-17-69-24-83S117.36,16.79,102.36,16.79Z" transform="translate(-0.53 -16.29)"/>
			</clipPath>
		</svg>

		<div class="container">    

			<div class="row justify-content-between align-items-center">
				<div class="col-sm-6 content">
					<p class="citation">	
La porte du changement ne peut s'ouvrir que de l'intérieur.
					</p>

					<div class="row justify-content-around" style="height: 50px;">
						
					</div>

					<div class="gauche">
						<transition name="FadeSlideGauche" appear><img style="" src="../assets/img/nasa-08-orange.svg"></transition>
					</div>
					<div class="particuliers" style="">
						<h3>Pour les Particuliers</h3>

						<p>La sophrologie comme méthode thérapeutique permet de développer une conscience sereine grâce à un entrainement basé sur des techniques de respiration, mouvements doux, visualisation.<br>
Il s’agit d’harmoniser le corps et l’esprit en faisant appel à vos propres ressources.<br>Vous apprenez à puiser dans le matériau le plus puissant qui soit : votre propre expérience de vie et plus particulièrement dans ce qui a été bon pour vous, ce qui est bon pour vous, ce qui sera bon pour vous dans l’avenir.</p>
					</div>
				</div>

				<div class="col-sm-6">
					<div style="position:inherit;z-index:5;">
						<img class="img-fluid" style="-webkit-clip-path:url(#transp);clip-path:url(#transp);max-width:80%;" src="../assets/img/pic04.jpg">
					</div>
					<div>
						<transition name="FadeSlideCentre" appear><img  class="centre" style="" src="../assets/img/nasa-01-blanc.svg"></transition>
					</div>
					<div>
						<transition name="FadeSlideDroite" appear><img  class="droite" style="" src="../assets/img/nasa-08-rose.svg"></transition>
					</div>
				</div>
			</div>

			<div class="row justify-content-between ">	
				<div class="col-sm-4 particuliers">
					<p>
						<span style="font-weight:bold;">Pour qui ? </span><br>
La sophrologie  s’adresse à toute personne qui souhaite changer ce qui « ne va pas » ou pour simplement développer son potentiel.
C’est un outil à portée de main, les exercices sont concrets , accessibles à tous à partir de 6 ans
					</p>
				</div>

				<div class="col-sm-4 particuliers">
					<p>
						<span style="font-weight:bold;">Comment se déroule une séance ?</span><br>
Lors de votre 1er rdv nous prenons le temps d’approfondir les raisons qui vous amènent et  les objectifs que vous souhaitez atteindre tout en offrant une première expérience de la sophrologie.<br>
Les séances suivantes  d’une heure sont alors personnalisées, chacune constituant une étape avec une thématique précise.
					</p>
				</div>
				<div class="col-sm-4 particuliers">
					<p>
					<span style="font-weight:bold;text-align: left;">Combien de temps dure un accompagnement ?</span><br>
La sophrologie est une thérapie brève, les effets (relaxation, détente) se font ressentir généralement dès la 1ere séance, cependant, pour mettre en place un travail spécifique il faut compter 6 à 10 séances en fonction de vos objectifs et de votre évolution.
					</p>
				</div>
			</div>

		</div>

	</section>
</template>

<script>

export default {
  name: 'Particuliers',
  metaInfo: function(){
	return{
    title: "Emmanuelle Vignon",
    titleTemplate: '%s | Sophrologue pour les Particuliers',
        meta: [
      { hid: "description", name: "description", content: " La sophrologie comme méthode thérapeutique permet de développer une conscience sereine grâce à un entrainement basé sur des techniques de respiration, mouvements doux, visualisation. " },
      { hid: "keywords", name: "keywords", content: " sophrologie, relaxation, blois, huisseau sur cosson, loir et cher, 41, méthode thérapeutique, sommeil, potentiel, méditation, bienêtre, sophrologue, détente, détente musculaire, corps, blocages, fatigue, harmonie, sérénité, lacher prise, stress, vitalité, accompagnement thérapeutique, maternité, paternité, confinace en soi, préparation aux examens, émotions, préparation mentale, harmonie, charge mentale, angoisses, blocages, douleurs chroniques, phobies, cohérence cardique " }      //you can also add open graph tags here
    ]
  }},
  components: {
    
    }
  }
</script>


<style scoped>
.particuliers{
	z-index: 4;
	position: relative;
}
.particuliers p{
	font-size: 16px;
	padding-top:10px;
	text-align: justify;
}
.particuliers h3{
	font-weight: 500;
}
.centre{
	height: 75%;
background: none;
position: absolute;
width: 75%;
z-index: 1;
bottom: -10%;
left: 5%;
}
.gauche{
	height: 60%;
position: absolute;
width: 50%;
z-index: 1;
bottom: -10%;
left: -30%;
clip-path:url(#rose);
-webkit-clip-path:url(#rose);
}
.droite{
	height: 75%;
position: absolute;
z-index: 1;
bottom: -5%;
right: 5%;
}

/*$$$$$$$$$ ANIMATIONS IMAGES $$$$$$$$*/

.FadeSlideDroite-enter-active, .FadeSlideDroite-leave-active {
  transition: all 10s cubic-bezier(.06, .97, .49, 1);
}
.FadeSlideDroite-enter, .FadeSlideDroite-leave-to  {
  opacity: 0;
  transform: translate(-50px,0);
  -webkit-transform: translate(-50px,0);
}
.FadeSlideCentre-enter-active, .FadeSlideCentre-leave-active {
  transition: all 6s cubic-bezier(.06, .97, .49, 1);
}
.FadeSlideCentre-enter, .FadeSlideCentre-leave-to {
  opacity: 0;
  transform: translate(25px,-25px);
  -webkit-transform: translate(25px,-25px);
}
.FadeSlideGauche-enter-active, .FadeSlideGauche-leave-active {
  transition: all 6s cubic-bezier(.06, .97, .49, 1);
}
.FadeSlideGauche-enter, .FadeSlideGauche-leave-to {
  opacity: 0;
  transform: translate(-25px,-25px);
  -webkit-transform: translate(-25px,-25px);
}

</style>